import {
  Avatar,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
} from '@chakra-ui/react';
import { PredictionsRankingItem } from '@/model/predictions';
import CenteredSpinner from '@/components/CenterSpinner/CenteredSpinner';
import { useTranslation } from 'react-i18next';

export interface PredictionsRankingModalProps extends Pick<ModalProps, 'isOpen' | 'onClose'> {
  isOpen: boolean;
  isLoading: boolean;
  items: PredictionsRankingItem[];
  onClose: () => void;
}

export const PredictionsRankingModal = ({ isOpen, isLoading, items, onClose }: PredictionsRankingModalProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent minW={{ md: '640px' }}>
          <ModalHeader>
            {t('pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_title')}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody display='flex' flexDirection='column' gap={4}>
            <Flex color='gray.500' fontSize='sm' fontWeight='bold' gap={4}>
              <Text w='24px'>#</Text>
              <Text flex='1'>
                {t('pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_fan_header')}
              </Text>
              <Text minW='72px' textAlign='right'>
                {t('pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_hits_header')}
              </Text>
              <Text minW='110px' textAlign='right'>
                {t(
                  'pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_percentage_header',
                )}
              </Text>
            </Flex>

            {items.length === 0 ? (
              <Text color='gray.500'>
                {t('pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_empty')}
              </Text>
            ) : (
              items.map(item => (
                <Flex key={item.account_uuid} alignItems='center' gap={4}>
                  <Text w='24px' fontWeight='bold' color='brand.500'>
                    {item.rank}
                  </Text>
                  <Flex flex='1' alignItems='center' gap={3}>
                    <Avatar size='sm' src={item.account_avatar_url} name={item.account_display_name} />
                    <Text>{item.account_display_name}</Text>
                  </Flex>
                  <Text minW='72px' textAlign='right'>
                    {item.total_hits}
                  </Text>
                  <Text minW='110px' textAlign='right' fontWeight='bold' color='brand.500'>
                    {item.hit_percentage.toFixed(0)}%
                  </Text>
                </Flex>
              ))
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant='outlined' color='gray.600' onClick={onClose}>
              {t('pages.application_predictions.components.predictions_ranking_modal.predictions_ranking_close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <CenteredSpinner isLoading={isLoading} />
    </>
  );
};
